// extracted by mini-css-extract-plugin
export default {"modal-body":"InvalidateWinnersModal_modal-body__iNFu6","body-text":"InvalidateWinnersModal_body-text__c9d0t"};